import {BaseContainerModel} from '../../base-container.model';
import {
  bl_b2b_payment_request_stmt_to_peppol_hdr_matching_link_RowClass
} from '../../../dbschema/index';

export class PmtStmtPeppolMatchingLinkContainer extends BaseContainerModel {
  bl_b2b_payment_request_stmt_to_peppol_hdr_matching_link: bl_b2b_payment_request_stmt_to_peppol_hdr_matching_link_RowClass = new bl_b2b_payment_request_stmt_to_peppol_hdr_matching_link_RowClass();

}
